export default __webpack_public_path__ + "static/people-b012ea490c8c251228c7d8d502a73d85.jpg";